module.exports = __webpack_public_path__ + "img/11_117.823636bb.png";